export default {
  FAQ_DATA_REQUEST: "faq/DATA_REQUEST",
  FAQ_DATA_SUCCESS: "faq/DATA_SUCCESS",
  FAQ_DATA_FAIL: "faq/DATA_FAIL"
};
